import api from "./cofocusAPI";

async function getConversations(startDateMS, stopDateMS, limit) {
  return api.getResponseData({
    url: `/api/messages/previews`,
    method: "get",
    params: {
      start: startDateMS,
      stop: stopDateMS,
      limit,
    },
    withCredentials: true,
  });
}

async function loadMoreMessages(connectionID, lastBatchNr, skip, limit) {
  console.log("@messengerAPI.loadMoreMessages arguments: ", connectionID, lastBatchNr, skip, limit);
  return api.getResponseData({
    url: `/api/messages/messages`,
    method: "get",
    params: {
      CID: connectionID,
      lastBatchNr: lastBatchNr,
      skip: skip,
      limit: limit,
    },
    withCredentials: true,
  });
}

async function getConversationByID(conversationID) {
  return api.getResponseData({
    url: `/api/messages/previews/${conversationID}`,
    method: "get",
    withCredentials: true,
  });
}

export async function checkUserHasNotifications() {
  return api.getResponseData({
    url: `/api/messages/notifications/status`,
    method: "get",
    withCredentials: true,
  });
}

export default {
  getConversations,
  loadMoreMessages,
  getConversationByID,
  checkUserHasNotifications,
};
